export const getFormattedPrice = (price: number): string => {
	const roundedPrice = Math.round(price * 100) / 100;

	// If it's a whole number, return without decimals
	if ((roundedPrice % 1) === 0) {
		return roundedPrice.toString() + ',-';
	}

	let priceAsString = roundedPrice.toString();
	priceAsString = priceAsString.replace('.', ',');

	// If there's only a single digit after the comma, append an extra zero
	if (priceAsString.split(',')[1].length === 1) {
		priceAsString = `${priceAsString}0`;
	}

	return priceAsString;
};

export const getFormattedTotalPrice = (price?: number | null, amount?: number | null) => {
	if (price === null || price === undefined) {
		return '';
	}

	if (amount) {
		return getFormattedPrice(amount * price);
	}

	return getFormattedPrice(price);
};
